import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { Nav, Tab } from "react-bootstrap";

import { withRouter } from "../../resusableComponents/hoc/withRouter";
import HistoryTab from "./components/historyTab";
import ExportTab from "./components/exportTab";

import { updatePageLevelLoadingState } from "../../redux/actions/application";

class History extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab: "history",
    };
  }

  render() {
    const { intl } = this.props;
    const { activeTab } = this.state;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "olympus.history", defaultMessage: "History: Olympus" })}
          </title>
        </Helmet>

        <div className="content-wrapper">
          <div className="container-fluid flex-grow-1 px-6 py-6">
            <div className="row gy-2">
              <div className="col-lg-12">
                <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase">
                  <FormattedMessage id="history.title" defaultMessage="history" />
                </h1>
              </div>
            </div>

            <div className="row gy-4 mt-0">
              <div className="col-lg-12">
                <div className="card shadow-none">
                  <div className="card-body">

                    <Tab.Container id="history-tabs" activeKey={activeTab} onSelect={(key) => this.setState({ activeTab: key })}>
                      <Nav variant="tabs" className="bg-white-f0 rounded-1 mb-5">
                        <Nav.Item>
                          <Nav.Link eventKey="history" className="text-capitalize">
                            <FormattedMessage id="btn.saved" defaultMessage="Saved" />
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="export" className="text-capitalize">
                            <FormattedMessage id="btn.exported" defaultMessage="Exported" />
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>

                      <Tab.Content>
                        <Tab.Pane eventKey="history">
                          <HistoryTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="export">
                          <ExportTab />
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(injectIntl(History)));
